/* eslint-disable @nx/enforce-module-boundaries */
/**
 * Implementing this context for search section
 * This module needs modifications in the future, to use methods from this context only
 */

import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useToast } from '@mybridge/ui/hooks';
import { useMutation } from '@tanstack/react-query';
import { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { followCompanyPage, unFollowCompanyPage } from 'v4/store/actions/companyPages.actions';
import { getAllConnectionIDs } from 'v4/store/actions/connection.actions';
export const CompanyPagesContext = createContext({});

export const useCompanyPagesContext = () => {
  const [currentAction, setCurrentAction] = useState(null);
  const toast = useToast({
    position: 'top',
    isClosable: true,
  });
  const { t } = useTranslator();
  const dispatch = useDispatch();
  const { allConnectionIDs } = useSelector((state) => state.connection);

  useEffect(() => {
    dispatch(getAllConnectionIDs());
  }, []);

  // follow company page mutation
  const followCompanyPageMut = useMutation({
    mutationKey: ['follow-company-page'],
    mutationFn: async (payload) => {
      return (await dispatch(followCompanyPage(payload)))?.payload;
    },
  });

  // unfollow company page mutation
  const unfollowCompanyPageMut = useMutation({
    mutationKey: ['unfollow-company-page'],
    mutationFn: async (payload) => {
      return (await dispatch(unFollowCompanyPage(payload)))?.payload;
    },
  });

  /**
   * follow company page
   * @param {*} data
   */
  const followCompanyPage_ = async (company) => {
    try {
      const resp = await followCompanyPageMut?.mutateAsync(company?.id);
      if (resp?.state_code >= 400) {
        toast({ title: t('toast.invalidDetails') || 'Invalid details provided!', status: 'error' });
      } else {
        // toast({
        //   title: 'You successfully followed a page!',
        //   status: 'success',
        // });
        dispatch(getAllConnectionIDs());
      }
    } catch (e) {
      toast({
        title: t('toast.followPageError') || 'Error while following page!',
        status: 'error',
      });
    }
  };

  /**
   * unfollow company page
   * @param {*} data
   */
  const unfollowCompanyPage_ = async (company) => {
    try {
      const resp = await unfollowCompanyPageMut?.mutateAsync(company?.id);
      if (resp?.state_code >= 400) {
        toast({ title: t('toast.invalidDetails') || 'Invalid details provided!', status: 'error' });
      } else {
        // toast({
        //   title: 'You successfully followed a page!',
        //   status: 'success',
        // });
        dispatch(getAllConnectionIDs());
      }
    } catch (e) {
      toast({
        title: t('toast.followPageError') || 'Error while following page!',
        status: 'error',
      });
    }
  };

  const {
    handshake_requests,
    handshake_received,
    circle,
    following,
    company_following_ids,
  } = allConnectionIDs ?? {};

  const isCompanyFollowed = (user) =>
    company_following_ids?.includes?.(user?.id);

  return {
    followCompanyPageMut,
    followCompanyPage: followCompanyPage_,
    unfollowCompanyPageMut,
    unfollowCompanyPage: unfollowCompanyPage_,
    isCompanyFollowed,
    currentAction,
    setCurrentAction
  };
};
